import type { LatLong } from '@iheartjane/geolocation';
import { distance as turfDistance } from '@turf/distance';

export const distance = (
  point1?: Partial<LatLong>,
  point2?: Partial<LatLong>
) => {
  if (
    point1?.lat === undefined ||
    point1?.long === undefined ||
    point2?.lat === undefined ||
    point2?.long === undefined
  ) {
    return '0';
  }

  const result = turfDistance(
    [point1.long, point1.lat],
    [point2.long, point2.lat],
    { units: 'miles' }
  );

  return isNaN(result) ? '0' : result.toFixed(1);
};
